import { useCallback } from 'react';

import { api } from '@shared/api';
import { TimesEnum } from '@shared/enums';
import { UserStore } from '@shared/store';

import { useQuery } from '@tanstack/react-query';
import { DateTime } from 'luxon';

type Props = {
  enabled?: boolean;
};

const useFetchPlannedMaintenance = ({ enabled }: Props) => {
  const { getUniqueIdentifier } = UserStore.useUserStore;

  const fetchPlannedMaintenance = useCallback(async () => {
    if (!getUniqueIdentifier()) return;

    let response = await api.endpoints.getMarginPlannedMaintenance();

    return response.data?.maintenance;
  }, [getUniqueIdentifier]);

  return useQuery({
    queryKey: ['margin-planned-maintenance', getUniqueIdentifier() || 'anonymous'],
    queryFn: fetchPlannedMaintenance,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    refetchInterval: (data) => {
      if (!data) return TimesEnum.MINUTE;

      if (data.startTime < DateTime.now().toMillis()) return TimesEnum.SECOND * 10;

      return false;
    },
    networkMode: 'always',
    retry: false,
    enabled,
  });
};

export { useFetchPlannedMaintenance };
